import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SitesDialogService} from "../../../sites/services/sites-dialogs-service.service";
import {SitesAlertsService} from "../../../sites/services/sites-alerts.service";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";


export class OrganizationSitesCtrl implements IController {
  organization: any;
  sites: any;

  public loading: boolean = false;

  constructor(private confirmDialogService: ConfirmDialogService, private sitesDialogService: SitesDialogService, private sitesRequestsService: SitesRequestsService,
              private $log, private sitesAlertsService: SitesAlertsService) {
  }

  onCreateSite(event) {
    this.sitesDialogService.createSite(event)
      .then((newSite) => {
        this.loading = true;
        return this.sitesRequestsService.createSite(this.organization.id, newSite)
      })
      .then((createdSite) => {
        this.sites.push(createdSite);
        this.sitesAlertsService.createSuccess();
      })
      .catch((error) => {
        if (error) {
          this.sitesAlertsService.createError();
          this.$log.error('Failed to create site', error)
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onDeleteSite(site) {
    const title = 'Delete Site';
    const confirmText1 = 'Deleting "{{name}}" will remove the site permanently.';
    const confirmText2 = 'Confirm deletion by typing the site ID below: {{id}}.';
    const placeholder = 'Enter site ID';
    const regex = site.id;
    this.confirmDialogService.confirmEntity(title, confirmText1, confirmText2, placeholder, site, regex)
      .then(() => {
        this.loading = true;
        return this.sitesRequestsService.deleteSite(site.id);
      })
      .then((deletedSite) => {
        this.sites = _.filter(this.sites, (s) => {
          return s.id !== deletedSite.id;
        });
        this.sitesAlertsService.deleteSuccess(deletedSite);
      })
      .catch((error) => {
        if (error) {
          this.sitesAlertsService.deleteError();
          this.$log.error('Failed to delete site', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


}


angular
  .module('bringoz.admin.organizations')
  .component('organizationSites', {
    bindings: {
      organization: '<',
      sites: '<'
    },
    template: require('./organization-sites.html').default,
    controller: OrganizationSitesCtrl
  });
